.horizontal {
  width: 100%;
  border: 0;
  border-top: 1px solid var(--color-border);
  margin: var(--space-4) 0;
}

.vertical {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1.25rem;
  background-color: var(--color-border);
  flex-shrink: 0;
}

.kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.375rem;
  height: 1.375rem;
  padding: 0 var(--space-1-5);
  border: 1px solid var(--color-border-strong);
  border-bottom-width: 2px;
  border-radius: var(--radius-sm);
  background-color: var(--color-surface-sunken);
  color: var(--color-text-muted);
  font-family: var(--font-sans);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  line-height: 1;
  white-space: nowrap;
}
